var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.004,
    height: 27.028,
    viewBox: "0 0 27.004 27.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Connecting-Users",
    d: "M27.655,29A1.348,1.348,0,0,0,29,27.649v-3.94a6.948,6.948,0,0,0-3.523-6.028,5.321,5.321,0,1,0-7.813-.009,7.021,7.021,0,0,0-2.16,1.916,7.007,7.007,0,0,0-2.167-1.909,5.319,5.319,0,1,0-7.814,0A6.95,6.95,0,0,0,2,23.709v3.94A1.349,1.349,0,0,0,3.349,29h8.7a1.349,1.349,0,1,0,0-2.7H4.7V23.709a4.268,4.268,0,0,1,4.264-4.263H9.9a4.269,4.269,0,0,1,4.264,4.263V26.3H11.574a1.349,1.349,0,1,0,0,2.7ZM9.43,11.467a2.619,2.619,0,1,1-2.619,2.619A2.621,2.621,0,0,1,9.43,11.467Zm12.145,0a2.618,2.618,0,1,1-2.619,2.618,2.621,2.621,0,0,1,2.619-2.618Zm-.467,7.979h.934A4.267,4.267,0,0,1,26.3,23.709V26.3H16.86V23.709a4.237,4.237,0,0,1,4.248-4.263ZM8.557,7.071a1.348,1.348,0,0,1-.12-1.9,9.389,9.389,0,0,1,14.115,0,1.349,1.349,0,0,1-2.024,1.784,6.717,6.717,0,0,0-5.033-2.282,6.8,6.8,0,0,0-5.033,2.282,1.326,1.326,0,0,1-1.9.12Z",
    transform: "translate(-2 -1.97)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.04e80a570e96d0d79e654292ecc5c996.svg";
export { ForwardRef as ReactComponent };